import { getCapabilities as viem_getCapabilities, } from 'viem/experimental';
import { getConnectorClient } from '../../actions/getConnectorClient.js';
/** https://wagmi.sh/core/api/actions/getCapabilities */
export async function getCapabilities(config, parameters = {}) {
    const { account, connector } = parameters;
    const client = await getConnectorClient(config, { account, connector });
    return viem_getCapabilities(client, { account: account });
}
//# sourceMappingURL=getCapabilities.js.map